import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { BrigadistaDBService } from '../database/brigadista-db.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class BrigadistaService extends BaseService{
    override classname: string = 'BrigadistaService';
    public override route: string = 'brigadista';
    public override database = Capacitor.isNativePlatform() ? new BrigadistaDBService() : new BrigadistaDBService();
}
